module.exports = __webpack_public_path__ + "img/معمولی.740bb6fb.png";